(() => {
  // app/scripts/common/component/stickyComponent.js
  customElements.define("sticky-component", class extends HTMLElement {
    connectedCallback() {
      this.stickyPoint = document.querySelector(this.dataset.stickyPoint) || null;
      if (!this.stickyPoint)
        return;
      window.addEventListener("load", () => {
        this.lastScroll = window.__earlyScrollY + 6;
        this.findPosition();
      });
      window.addEventListener("scroll", (e) => {
        this.findPosition();
      });
      this.style.setProperty("--min-height", this.scrollHeight + "px");
      window.addEventListener("resize", () => {
        this.style.setProperty("--min-height", this.scrollHeight + "px");
      });
    }
    findPosition() {
      const { scrollY: windowTop } = window;
      const targetTop = this.stickyPoint.getBoundingClientRect().top + document.documentElement.scrollTop;
      if (windowTop > targetTop && this.lastScroll <= targetTop) {
        this.toggleWidget = true;
      } else if (windowTop < targetTop && this.lastScroll >= targetTop) {
        this.toggleWidget = false;
      }
      this.lastScroll = windowTop;
    }
    set toggleWidget(boolean) {
      boolean ? this.show() : this.close();
    }
    show() {
      this.detectOtherSticky();
      this.classList.add("active");
      this.dataset.bodyClass && document.body.classList.add(this.dataset.bodyClass);
    }
    close() {
      this.classList.remove("active");
      this.dataset.bodyClass && document.body.classList.remove(this.dataset.bodyClass);
    }
    detectOtherSticky() {
      const { inViewPort } = theme;
      const array = [];
      document.querySelectorAll("sticky-component").forEach((item) => {
        if (item != this) {
          item.getStickyEl && array.push(item.getStickyEl);
        }
      });
      const headerSticky = document.querySelector("sticky-header");
      headerSticky && array.push(headerSticky);
      array.forEach((item) => {
        inViewPort(item, () => {
          const { bottom } = item.getBoundingClientRect();
        }, true);
      });
    }
    get getStickyEl() {
      if (this.classList.contains("jsStickyEl"))
        return this;
      return this.querySelector(".jsStickyEl") || null;
    }
  });

  // app/scripts/common/component/infinite-load.js
  var infiniteLoading = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.dataset.url.length)
        return;
      window.addEventListener("scroll", this.onScrollHandler.bind(this), false);
    }
    disconnectedCallback() {
      this.removeEvents();
    }
    removeEvents(remove) {
      window.removeEventListener("scroll", this.onScrollHandler.bind(this), false);
      remove && this.remove();
    }
    onScrollHandler() {
      if (this.getBoundingClientRect().top < 1 || this.getBoundingClientRect().top > window.innerHeight || this.waiting)
        return;
      this.fetch();
    }
    fetch() {
      if (!this.dataset.url.includes("page"))
        return;
      this.waiting = true;
      this.classList.add("loading");
      if (!this.dataset.url.length) {
        this.disconnectedCallback();
        return;
      }
      var url = this.dataset.url;
      url += url.includes("?") ? "&" : "?";
      var new_url = url.replace(this.dataset.id, "");
      console.log("new_url", new_url);
      history.pushState("", "", new_url.slice(0, -1));
      fetch(url).then((e) => e.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        this.render(div);
        div.remove();
        this.waiting = false;
        this.classList.remove("loading");
      });
    }
    render(newContent) {
      if (newContent.querySelector(".list-products") == null)
        return;
      Array.from(newContent.querySelector(".list-products")?.children)?.forEach((item) => {
        if (item.classList.contains("info-card"))
          return;
        document.querySelector(".list-products").insertAdjacentElement("beforeend", item);
      });
      this.setAttribute("data-url", newContent.querySelector(this.tagName)?.dataset.url);
      if (!this.dataset.url.length) {
        this.removeEvents(true);
      }
    }
  };
  customElements.define("infinite-loading", infiniteLoading);

  // app/scripts/common/component/revert-load.js
  var revertLoading = class extends HTMLElement {
    constructor() {
      super();
      this.querySelector(".js-load-more")?.addEventListener("click", () => {
        this.fetch();
      });
      this.loading = this.querySelector(".svg_loading");
    }
    connectedCallback() {
    }
    fetch() {
      if (!this.dataset.url.includes("page"))
        return;
      this.waiting = true;
      this.classList.add("loading");
      if (!this.dataset.url.length) {
        this.disconnectedCallback();
        return;
      }
      var url = this.dataset.url;
      url += url.includes("?") ? "&" : "?";
      fetch(url).then((e) => e.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        this.render(div);
        div.remove();
        this.waiting = false;
        this.classList.remove("loading");
      });
    }
    render(newContent) {
      if (newContent.querySelector(".list-products") == null)
        return;
      Array.from(newContent.querySelector(".list-products")?.children)?.reverse().forEach((item) => {
        if (item.classList.contains("info-card"))
          return;
        document.querySelector(".list-products").insertAdjacentElement("afterbegin", item);
      });
      let url = newContent.querySelector(this.tagName)?.dataset.url;
      if (url != void 0) {
        this.setAttribute("data-url", newContent.querySelector(this.tagName)?.dataset.url);
      } else {
        this.remove();
      }
      if (!this.dataset.url.length) {
        this.removeEvents(true);
      }
    }
  };
  customElements.define("revert-loading", revertLoading);

  // app/scripts/filter-page.js
  document.querySelectorAll(".sidebar-filter .jsClose")?.forEach((e) => {
    e.addEventListener("click", () => {
      document.querySelector(".main-filter").classList.remove("active");
    });
  });
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelector("body").style.setProperty("--header-height", document.querySelector("#theme-header").offsetHeight + "px");
  });
})();
